export class ManualEntryDialogController {
  public static $inject = ['$mdDialog', '$translate', '$mdMedia', 'title', 'okText', 'cancelText'];
  public title: string;
  public okText: string;
  public cancelText: string;
  public currentLocale: string;
  public productName: string;
  public oid: string;
  public typ: string;
  public ptyp: string;
  public cpicc: string;

  constructor(
    private $mdDialog: ng.material.IDialogService,
    $translate: ng.translate.ITranslateService,
    private $mdMedia,
    title: string,
    okText: string,
    cancelText: string) {
    this.currentLocale = $translate.use();
    this.title = $translate.instant(title);
    this.okText = angular.isUndefined(okText) ? $translate.instant('DIALOG_COMMON.YES') : $translate.instant(okText);
    this.cancelText = angular.isUndefined(cancelText) ? $translate.instant('DIALOG_COMMON.NO') : $translate.instant(cancelText);
  }

  /**
   * Function which is used to complete a dialog action
   */
  public ok = () => {
    this.$mdDialog.hide(this.constructProductObject());
  }

  public isScreenSmall = () => {
    if (this.$mdMedia('sm')) {
      return 'input-cpicc-100';
    }
    return 'input-cpicc';
  }

  /**
   * Function which is used to cancel a dialog action
   */
  public cancel = () => {
    this.$mdDialog.cancel();
  }

  /**
   * Function which is used to construct a correctly formatted product object
   */
  private constructProductObject() {
    return {
      description: this.productName,
      oid: this.oid,
      typ: this.typ,
      ptyp: this.ptyp,
      cpicc: this.cpicc
    };
  }
}